import { PageTitle } from 'utils/constants/pageTitles'
import OverviewFlexBox from './OverviewFlexBox'
import { StatDataModel } from 'api/data-contracts'

interface OverviewPanelProps {
  statsData?: StatDataModel[]
}
const OverviewPanel = ({ statsData }: OverviewPanelProps) => {
  return (
    <>
      <div className="flex">
        <h2 className="fw-500 mb-20">{PageTitle.ACTIVE_COURSES_OVERVIEW}</h2>
      </div>

      {statsData && (
        <div className="flex flex-wrap">
          {/* Brittle client side removal of 'Courses' box, 'Active courses' should now be the first Card. needs removing from backend ideally */}
          {statsData?.slice(1).map((value, index) => (
            <OverviewFlexBox
              title={value.statName!}
              amount={value.statValue!}
              key={index}
            />
          ))}
        </div>
      )}
    </>
  )
}

export default OverviewPanel
